import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  // Don't show on game pages
  const isGamePage = location.pathname.startsWith("/game/");

  const toggleVisibility = () => {
    setIsVisible(window.scrollY > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && !isGamePage && (
        <motion.button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 p-3 font-bold transition-all z-40 rounded-neo-xs"
          style={{
            backgroundColor: "var(--color-primary)",
            color: "var(--color-surface)",
            border: "3px solid var(--color-text-primary)",
            boxShadow: "6px 6px 0px rgba(0, 0, 0, 0.2)",
          }}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          whileHover={{ scale: 1.15, y: -2 }}
          whileTap={{ scale: 0.95 }}
          data-testid="scroll-to-top-button"
          title="Scroll to top"
        >
          <span className="text-xl">↑</span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
